import React from 'react';
import { IHeader } from './interfaces';
import { Typography } from '@mui/material';

export const Header: React.FC<IHeader> = ({ label, children }): JSX.Element => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <Typography fontWeight="bold" variant="body2">
        {label}
      </Typography>
      {children}
    </div>
  );
};
